import { useSellarUser } from "../../../../../hooks";
import { UserOptInMarketingStepContent } from "./UserOptInMarketingStepContent";

export const UserOptInMarketingStep = () => {
  const { user } = useSellarUser();
  if (!user?.UserNotificationPreferenceId) throw new Error("No user exists");
  return (
    <UserOptInMarketingStepContent
      userNotificationPreferenceId={user.UserNotificationPreferenceId}
    />
  );
};
